module.exports = __webpack_public_path__ + "assets/5ad7a8941c96989c31efd08902c9f5f7.svg";